/**
 * 클립보드 유틸리티
 * - 텍스트를 클립보드에 복사
 * - navigator.clipboard API 우선 사용, 폴백 제공
 */

/**
 * 텍스트를 클립보드에 복사
 * @param {string} text - 복사할 텍스트
 * @returns {Promise<boolean>} - 성공 여부
 */
export const copyToClipboard = async (text) => {
  // 최신 Clipboard API 사용 (보안 컨텍스트 필요)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      // 폴백으로 진행
    }
  }

  // 폴백: 구버전 브라우저용 execCommand
  return copyToClipboardFallback(text)
}

/**
 * execCommand를 사용한 폴백 복사
 * @param {string} text - 복사할 텍스트
 * @returns {boolean} - 성공 여부
 */
const copyToClipboardFallback = (text) => {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // 화면 밖으로 이동
  textArea.style.cssText = `
    position: fixed;
    left: -9999px;
    top: -9999px;
    width: 1px;
    height: 1px;
    opacity: 0;
  `

  document.body.appendChild(textArea)

  // 기존 선택 영역 저장
  const selection = document.getSelection()
  const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : null

  textArea.select()

  let success = false
  try {
    success = document.execCommand('copy')
  } catch (_) {
    /* execCommand copy may not be supported */
  }

  document.body.removeChild(textArea)

  // 기존 선택 영역 복원
  if (selected) {
    selection.removeAllRanges()
    selection.addRange(selected)
  }

  return success
}

/**
 * 주소를 클립보드에 복사 (기존 addrCopy 함수 대체)
 * @param {string} address - 복사할 주소
 * @returns {Promise<boolean>}
 */
export const copyAddress = async (address) => {
  return copyToClipboard(address)
}

export default {
  copyToClipboard,
  copyAddress,
}
